import { render, staticRenderFns } from "./DetailPlan.vue?vue&type=template&id=d1a308e6&scoped=true&"
import script from "./DetailPlan.vue?vue&type=script&lang=ts&"
export * from "./DetailPlan.vue?vue&type=script&lang=ts&"
import style0 from "./DetailPlan.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DetailPlan.vue?vue&type=style&index=1&id=d1a308e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a308e6",
  null
  
)

export default component.exports